export default __webpack_public_path__ + "static/media/HAKKA-BUSD.7cdb4d82.svg";